"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const PaymentUtilities_1 = require("../PaymentUtilities");
const date_fns_1 = require("date-fns");
/**
 * Returns whether a credit card account should be prompted with autopay enrollment.
 * @param creditCardAccount a credit card account with autopay data available
 * @returns whether the input credit card account should be prompted to enroll in Autopay
 */
exports.creditCardShouldShowAutopayEnroll = (creditCardAccount) => {
    const { autopayActive, locked, overlimit, wasClosed, pastDue } = creditCardAccount;
    return (!locked && !autopayActive && !overlimit && !wasClosed && !pastDue);
};
/**
 * @ignore
 * This represents the avaliable autopay strategies for a credit card
 */
var CreditCardAutopayStrategy;
(function (CreditCardAutopayStrategy) {
    CreditCardAutopayStrategy["min"] = "min";
    CreditCardAutopayStrategy["statement"] = "statement";
})(CreditCardAutopayStrategy = exports.CreditCardAutopayStrategy || (exports.CreditCardAutopayStrategy = {}));
/**
 * @ignore
 * Returns the total amount for all scheduled payments prior to a specific date
 * @param payments a list of payments that implement `ICreditCardMinimumDuePayment`
 * @param date the date before which we are collecting payment amounts
 * @returns the total amount (in cents) of all payments in the input payments list which are due before the input date
 */
const totalForPaymentsPriorToDate = (payments, date) => payments
    .filter(({ status }) => status === PaymentUtilities_1.CreditCardPaymentStatus.scheduled)
    .filter(({ postDate }) => postDate && !date_fns_1.isAfter(postDate, date))
    .reduce((total, { amount: { cents } }) => total + cents, 0);
/**
 * Returns whether a credit card account has satisfied it's minimum payment due requirement
 * @param payments a list of payments that implement `ICreditCardMinimumDuePayment`
 * @param adjustedMinimumDueCents the amount (in cents) of the adjusted minimum due
 * @param minPaymentDueDate the date that the minimum payment is due
 * @returns a boolean representing whether or not the payment total
 *  for payments scheduled prior to the minimum due date exceeds the minimum amount due
 */
exports.creditCardSatisfiedMinPayDue = (payments, adjustedMinimumDueCents, minPaymentDueDate) => {
    // the min due is considered satisfied if there is no due date or no amount due
    if (!minPaymentDueDate || !adjustedMinimumDueCents) {
        return true;
    }
    // compute the total amount for payments scheduled prior to the due date
    const paymentsTotal = totalForPaymentsPriorToDate(payments, minPaymentDueDate);
    // the min due is satisfied if the payment total is greater than the minimum due
    return paymentsTotal >= adjustedMinimumDueCents;
};
